import { AssertIsNotNilException } from './assert-is-not-nil.exception';
import { isNil } from '@pct-ts/typeguard';

export function assertIsNotNil<T>(value: T, message: string): asserts value is NonNullable<T> {
  if (isNil(value)) {
    throw new AssertIsNotNilException(`Is a nil: ${message}`);
  }
}
